// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"a0305d30","450":"237de76a","563":"6aac979d","887":"7ba17fc8"}[chunkId] + ".chunk.css";
};